import produce from 'immer';
import { Reducer } from 'redux';

import {
  IDynamicTableActionsType,
  IDynamicTableTypes,
  IDynamicTableState,
} from './types';

const INITIAL_STATE: IDynamicTableState = {
  loading: false,
  dynamicTableColumns: undefined,
};

const dynamicTable: Reducer<IDynamicTableState, IDynamicTableActionsType> = (
  state = INITIAL_STATE,
  action: IDynamicTableActionsType,
) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case IDynamicTableTypes.DYNAMIC_TABLE_REQUEST: {
        draft.loading = true;
        draft.dynamicTableColumns = undefined;
        break;
      }
      case IDynamicTableTypes.DYNAMIC_TABLE_SUCCESS: {
        draft.loading = false;
        draft.dynamicTableColumns = action.payload.dynamicTable;
        break;
      }
      case IDynamicTableTypes.DYNAMIC_TABLE_FAILURE: {
        draft.loading = false;
        break;
      }
      default:
    }
  });
};
export default dynamicTable;
